import { useIntl } from "react-intl";

import { LoggedOutBlueWaveTemplateJsm } from "../components";

export const LoggedOutJsmStandard = () => {
    const { formatMessage } = useIntl();

    return (
        <LoggedOutBlueWaveTemplateJsm
            productEditionText={formatMessage({
                id: "WacSignupHeader.cloudStandard",
                defaultMessage: "Cloud Standard"
            })}
        />
    );
};
